/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import Icons from '../../icons/icons';
import { SearchInput } from './search-input';


interface SearchWithNavigationProps {
  // Search input props
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  placeholder?: string;

  // Navigation props
  // Array of search matches
  matches: any[];
  // Current match index (0-based)
  currentIndex: number;
  onPreviousMatch: () => void;
  onNextMatch: () => void;

  // Styling props
  className?: string;
  inputClassName?: string;
  searchWidth?: string;
  disabled: boolean;
}

const SearchWithNavigation = ({
  value,
  onChange,
  onClear,
  placeholder = 'Search',
  matches,
  currentIndex,
  onPreviousMatch,
  onNextMatch,
  className = '',
  inputClassName = '',
  searchWidth = 'w-[250px]',
  disabled = false,
}: SearchWithNavigationProps) => {
  return (
    <div
      className={`relative ${className} ${disabled ? 'pointer-events-none opacity-50' : ''}`}
    >
      {/* Search Input */}
      <SearchInput
        value={value}
        onChange={onChange}
        onClear={onClear}
        placeholder={placeholder}
        className={searchWidth}
        inputClassName={`pr-20 ${inputClassName}`}
      />

      {/* Navigation Controls - Only show when there's a search term */}
      {value && (
        <div className="absolute inset-y-0 right-[30px] flex items-center gap-[6px] text-white">
          {/* Match Counter */}
          <span className="text-form-input-text">
            {matches.length ? `${currentIndex + 1}/${matches.length}` : '0/0'}
          </span>

          {/* Previous Match Button */}
          <button
            onClick={onPreviousMatch}
            disabled={matches.length === 0 || currentIndex === 0}
            className="text-ocean disabled:text-form-control-border-disabled"
            aria-label="Previous match"
          >
            {Icons.UpArrowIcon('w-4 h-4')}
          </button>

          {/* Next Match Button */}
          <button
            onClick={onNextMatch}
            disabled={
              matches.length === 0 || currentIndex === matches.length - 1
            }
            className="text-ocean disabled:text-form-control-border-disabled"
            aria-label="Next match"
          >
            {Icons.DownArrowIcon('w-4 h-4')}
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchWithNavigation;
